// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_hu-0";
export var buttonContainer = "_hu-3";
export var cancelButton = "_hu-4";
export var headerSection = "_hu-6";
export var headerTitle = "_hu-9";
export var messageSideLeft = "_hu-1";
export var messageSideRight = "_hu-2";
export var orderNumberContainer = "_hu-7";
export var orderNumberLabel = "_hu-8";
export var submitButton = "_hu-5";